import { Transform, TransformationType } from 'class-transformer';
import dayjs from 'dayjs';

/**
 * Transforms string decimal values (from JSON-serialized Python Decimals) to numbers.
 */
export function TransformStringToNumber() {
  return Transform(({ value, type }) => {
    if (value === null || value === undefined) {
      return value;
    }

    switch (type) {
      case TransformationType.PLAIN_TO_CLASS:
      case TransformationType.CLASS_TO_CLASS:
        return typeof value === 'string' ? Number(value) : value;
      case TransformationType.CLASS_TO_PLAIN:
        return value;
      default:
        return value;
    }
  });
}

export function TransformStringToDayJS(dateOnly = false) {
  return Transform(({ value, type, key }) => {
    if (value !== null && value !== undefined) {
      switch (type) {
        case TransformationType.PLAIN_TO_CLASS:
        case TransformationType.CLASS_TO_CLASS:
          if (dayjs.isDayjs(value)) {
            return value.clone();
          }

          return dayjs.utc(value as string);
        case TransformationType.CLASS_TO_PLAIN:
          if (dayjs.isDayjs(value)) {
            if (dateOnly) {
              return value.format('YYYY-MM-DD');
            }

            return value.toISOString();
          }

          return value as string;
        default:
          return value as string;
      }
    }

    return value;
  });
}
